import { render, staticRenderFns } from "./MenuManage.vue?vue&type=template&id=bda7ae38"
import script from "./MenuManage.vue?vue&type=script&lang=js"
export * from "./MenuManage.vue?vue&type=script&lang=js"
import style0 from "./MenuManage.vue?vue&type=style&index=0&id=bda7ae38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports